import { getChestApiUrl } from '../../helpers/index';

/**
 * Get search query based on user session.
 * 
 * @param {String} session The user session
 */
const getSearchQuery = (session) => {
  try {
    if (session) {
      const params = `s=${session}`;
      const url = `${getChestApiUrl()}/chestApi/data/h/search?${params}`;

      return fetch(url)
        .then(r => r.json())
        .catch(err => console.error(err));

    } else {
      throw new Error('NO SESSION');
    }
  } catch (err) {
    throw err;
  }
}

export default {
  getSearchQuery
}